import {
  ADD_ASPIRATIONS_QUESTION,
  EDIT_ASPIRATIONS_QUESTION,
  LIST_ASPIRATIONS_QUESTION,
  VIEW_ASPIRATIONS_QUESTION,
  DELETE_ASPIRATIONS_QUESTION,
  // text
  ADD_ASPIRATIONS_TEXT,
  EDIT_ASPIRATIONS_TEXT,
  LIST_ASPIRATIONS_TEXT,
  VIEW_ASPIRATIONS_TEXT,
  DELETE_ASPIRATIONS_TEXT,
  ASPIRATIONS_SUCCESS,
  ASPIRATIONS_ERROR,

} from "./actionTypes"

// add aspiration question
export const addAspirationQuestion = (data, history, callback) => {
  return {
    type: ADD_ASPIRATIONS_QUESTION,
    payload: { data, history, callback }
  }
}

// edit aspiration question
export const editAspirationQuestion = (data, id, callback) => {
  return {
    type: EDIT_ASPIRATIONS_QUESTION,
    payload: { data, id, callback },
  }
}

// list aspiration question
export const listAspirationQuestion = (data, callback) => {
  return {
    type: LIST_ASPIRATIONS_QUESTION,
    payload: { data, callback },
  }
}

// view aspiration question
export const viewAspirationQuestion = (data, history) => {
  return {
    type: VIEW_ASPIRATIONS_QUESTION,
    payload: { data, history },
  }
}

// delete aspiration question
export const deleteAspirationQuestion = (data, callback) => {
  return {
    type: DELETE_ASPIRATIONS_QUESTION,
    payload: { data, callback },
  }
}

// text
// add aspiration text
export const addAspirationText = (data, history, callback) => {
  return {
    type: ADD_ASPIRATIONS_TEXT,
    payload: { data, history, callback }
  }
}

// edit aspiration text
export const editAspirationText = (data, id, callback) => {
  return {
    type: EDIT_ASPIRATIONS_TEXT,
    payload: { data, id, callback },
  }
}

// list aspiration text
export const listAspirationText = (data, id, callback) => {
  return {
    type: LIST_ASPIRATIONS_TEXT,
    payload: { data, id, callback },
  }
}

// view aspiration text
export const viewAspirationText = (data, history) => {
  return {
    type: VIEW_ASPIRATIONS_TEXT,
    payload: { data, history },
  }
}

// delete aspiration text
export const deleteAspirationText = (data, callback) => {
  return {
    type: DELETE_ASPIRATIONS_TEXT,
    payload: { data, callback },
  }
}

export const aspirationSuccess = message => {
  return {
    type: ASPIRATIONS_SUCCESS,
    payload: message,
  }
}

export const aspirationError = message => {
  return {
    type: ASPIRATIONS_ERROR,
    payload: message,
  }
}
